var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip-toggle",attrs:{"aria-label":_vm.text,"tabindex":"0"}},[_c('span',{staticClass:"icon icon-info"})])}
var staticRenderFns = []

export { render, staticRenderFns }